import { reactive } from 'vue';
import store from '@/store';

// 放到全局，只需要在imageEditor里watch一次把他保存到store里
// 如果放在默认导出内部的话需要在导入到所有地方都watch一遍
const editorSize = reactive({});
export default ({ appState }) => {
  function resetEditorSize() {
    const { gap } = appState.value.editorSize;
    const { isCompareMode } = appState.value;
    const wrapWidth = window.innerWidth - gap * 3 - 80 - 278;
    const wrapHeight = window.innerHeight - gap * 2 - 56;

    editorSize.wrapWidth = isCompareMode ? wrapWidth / 2 : wrapWidth;
    editorSize.wrapHeight = isCompareMode ? wrapHeight : wrapHeight;
  }

  // 在imageeditor的onMounted里调用
  // -> resetEditorSize 得到wrap宽高
  // -> 得到canvas宽高
  const getImage = RmUrl => {
    editorSize.canvasReady = false;
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = RmUrl;
      img.onload = () => {
        resetEditorSize();
        const { naturalWidth, naturalHeight } = img;
        editorSize.canvasWidth = naturalWidth;
        editorSize.canvasHeight = naturalHeight;
        editorSize.canvasReady = true;
        store.commit('app/patchCropInfo', [{ width: naturalWidth, height: naturalHeight }, true]);
        const { wrapWidth, wrapHeight } = editorSize;
        const min = Math.min((wrapWidth * 0.4) / naturalWidth, (wrapHeight * 0.4) / naturalHeight);
        const max = Math.max((wrapWidth * 1.5) / naturalWidth, (wrapHeight * 1.5) / naturalHeight);
        store.commit('app/SET_STATE', {
          canvasMinScale: min > 0.4 ? 0.4 : min < 0 ? 0.1 : min,
          canvasMaxScale: max < 1.5 ? 1.5 : Math.floor(max),
        });
        resolve({ width: naturalWidth, height: naturalHeight });
      };
      img.onerror = err => {
        // console.error(222, RmUrl, err);
        reject('图片加载失败');
      };
    });
  };

  return {
    editorSize,
    getImage,
    resetEditorSize,
  };
};
